import * as React from 'react';
import { useParams, useLocation } from 'react-router-dom';

import { useGoToPath } from 'catering/hooks/navigation';
import { useCart } from 'catering/hooks/query';
import { ALL_CATERING_FULFILLMENT_METHODS } from 'constants/fulfillmentOptions';
import { buildOrderSettingsPath } from 'catering/helpers/paths';

/**
 *
 * @param {*Object} cart Object that contains fulfillment settings
 * @returns bool based on cart settings necessary to place order -- fulfillment method, date, time, address
 */

function haveFulfillmentOptionsBeenSet({
  catering_fulfillment_method,
  fulfillment_date,
  shipping_street_address_1
}) {
  // NOTE: shipping_street_address_1 can be either the delivery address for customer or the pickup address of the catering location
  return (
    ALL_CATERING_FULFILLMENT_METHODS.includes(catering_fulfillment_method) &&
    fulfillment_date &&
    shipping_street_address_1
  );
}

// TODO - should this check if the fulfillment settings are still valid?
export function useRedirectToOrderSettingsForNoFulfillmentSettings() {
  const location = useLocation();
  const { locationSlug } = useParams();
  const { go } = useGoToPath();
  const { data: cart } = useCart();

  const path = buildOrderSettingsPath({ locationSlug });
  const isOrderSettingsRoute = location.pathname.includes('order-settings');

  React.useEffect(() => {
    if (cart && !haveFulfillmentOptionsBeenSet(cart) && !isOrderSettingsRoute) {
      go({ path, isRedirect: true });
    }
  }, [cart, location]);
}
